import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { Box, BoxName, Row  } from './styled';

export const Message = ({ created_at, highlighted, text, name, user }) => (
    <div>
        <Row user={ user }>
            <BoxName user={ user }>
                { `${ name }, ${ created_at ? moment(created_at).format('hh:mm:ss a') : '' }` }
            </BoxName>
        </Row>
        <Row user={ user }>
            <Box highlighted={ highlighted } user={ user }>{ text }</Box>
        </Row>
    </div>
);

Message.propTypes = {
    created_at: PropTypes.string,
    highlighted: PropTypes.bool,
    name: PropTypes.string,
    text: PropTypes.string,
    user: PropTypes.string
};
